import { HERO_IMAGE } from '../data/content'
import {
  HERO_SIZES,
  HERO_WIDTHS,
  IMAGE_PROXY_ORIGIN,
  optimizedImage,
  optimizedSrcSet,
} from './images'

// Only the display face is downloaded; body copy uses the system UI stack.
const FONT_HREF = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&display=swap'

function addLink(attrs: Record<string, string>): void {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
}

function setMeta(name: string, content: string, attr: 'name' | 'property' = 'name'): void {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

/**
 * Runs before render: preloads the LCP image, loads the display font without
 * blocking, and fills in SEO metadata.
 */
export function setupPage(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'es'

  // LCP first: preload the exact responsive candidate the hero will pick.
  addLink({ rel: 'preconnect', href: IMAGE_PROXY_ORIGIN, crossorigin: '' })
  addLink({
    rel: 'preload',
    as: 'image',
    href: optimizedImage(HERO_IMAGE, 576),
    imagesrcset: optimizedSrcSet(HERO_IMAGE, HERO_WIDTHS),
    imagesizes: HERO_SIZES,
    fetchpriority: 'high',
  })

  // Display font: non-blocking, low priority (headings fall back to Georgia meanwhile).
  addLink({ rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' })
  const fontSheet = document.createElement('link')
  fontSheet.rel = 'stylesheet'
  fontSheet.href = FONT_HREF
  fontSheet.media = 'print'
  fontSheet.onload = () => {
    fontSheet.media = 'all'
  }
  document.head.appendChild(fontSheet)

  const title = 'Mega Kit Integración Campo-PLC-SCADA 2026 — Sensor a Sistema'
  document.title = title
  setMeta(
    'description',
    'Mega Kit Integración Campo-PLC-SCADA: 6 volúmenes técnicos y 6 bonos para docentes de Hispanoamérica. Señales 4-20mA, escalamiento, PLC, HMI, Modbus, MQTT e Industria 4.0. Acceso inmediato por $19 USD.',
  )
  setMeta('theme-color', '#2A2621')
  setMeta('og:title', title, 'property')
  setMeta(
    'og:description',
    '6 volúmenes técnicos + 6 bonos de implementación docente. Precio de lanzamiento $19 USD con garantía de 7 días.',
    'property',
  )
  setMeta('og:image', optimizedImage(HERO_IMAGE, 1000), 'property')
  setMeta('og:type', 'website', 'property')
  setMeta('twitter:card', 'summary_large_image')
}
